import React, { useState } from 'react';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Card, CardContent } from '../../../components/ui/card';
import AppShell from '../../../components/AppShell';

import { Loader2, RefreshCw, Send } from 'lucide-react';

const dummyThreads = [
  { id: 1, name: 'Aisha Beauty', platform: 'WhatsApp', lastMessage: 'When is my appointment?' },
  { id: 2, name: 'Nadia IG', platform: 'Instagram', lastMessage: 'Do you have Friday slots?' },
];

export default function ReplyBotInbox() {
  const [selectedThread, setSelectedThread] = useState(dummyThreads[0]);
  const [messages, setMessages] = useState([
    { from: 'user', text: selectedThread.lastMessage },
  ]);
  const [reply, setReply] = useState('');
  const [loading, setLoading] = useState(false);

  const generateReply = async () => {
    setLoading(true);
    // Placeholder: Replace with GPT API call
    setTimeout(() => {
      setReply('Hi! Yes, we’re available Friday. Would you like 4PM or 6PM?');
      setLoading(false);
    }, 1200);
  };

  const sendReply = () => {
    setMessages([...messages, { from: 'bot', text: reply }]);
    setReply('');
  };

  return (
    <AppShell>
        <div className="col-span-12 space-y-12">
    <div className="grid grid-cols-1 md:grid-cols-3 h-screen">
      {/* Thread List */}
      <div className="border-r p-4 overflow-y-auto space-y-2">
        <h2 className="text-lg font-semibold mb-4">Conversations</h2>
        {dummyThreads.map((t) => (
          <Card
            key={t.id}
            className={`mb-2 cursor-pointer ${t.id === selectedThread.id ? 'bg-gray-100' : ''}`}
            onClick={() => setSelectedThread(t)}
          >
            <CardContent className="p-3">
              <div className="font-medium">{t.name}</div>
              <div className="text-xs text-muted-foreground">{t.lastMessage}</div>
              <div className="text-xs">{t.platform}</div>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Chat Window */}
      <div className="col-span-2 flex flex-col justify-between">
        <div className="p-4 overflow-y-auto flex-grow">
          <h2 className="text-lg font-bold mb-2">{selectedThread.name}</h2>
          {messages.map((msg, idx) => (
            <div
              key={idx}
              className={`mb-2 text-sm ${
                msg.from === 'bot' ? 'text-right text-blue-600' : 'text-left text-gray-800'
              }`}
            >
              {msg.text}
            </div>
          ))}
        </div>

        {/* Reply Controls */}
        <div className="p-4 border-t flex gap-2 items-center">
          <Input
            placeholder="Type your reply or use AI..."
            value={reply}
            onChange={(e) => setReply(e.target.value)}
          />
          <Button variant="outline" onClick={generateReply} disabled={loading}>
            {loading ? <Loader2 className="animate-spin w-4 h-4" /> : <RefreshCw className="w-4 h-4" />}
          </Button>
          <Button onClick={sendReply} disabled={!reply}>
            <Send className="w-4 h-4 mr-1" /> Send
          </Button>
        </div>
      </div>
    </div>
    </div>
    </AppShell>
  );
}
